export const TRANSACTION_RATING_CLOSED_TIME_LS_KEY = 'transactions_rating_closed_time'
export const UPWORK_URL = 'https://www.upwork.com/'
